import { stepNames } from '../../types';
import { additionalDataType } from './types';

/**
 * Appends variables to the flow based on the step.
 *
 * @param {stepNames} stepName The name of the step.
 * @returns {Record<string, unknown> | null} The variables to append.
 */
export const appendVariablesMap = (stepName: stepNames, additionalData: additionalDataType) => {
  switch (stepName) {
    case 'REPAYMENT_TERMS':
      return process.env.NEXT_PUBLIC_ONB_INSTANCE_TYPE === 'onb-cuotas'
        ? {
            desiredAmount: parseFloat(additionalData.price || '0'),
          }
        : null;
    default:
      return null;
  }
};
